// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-card img[data-v-d300426a]{width:20%!important}.product-breakdown[data-v-d300426a]{margin-bottom:10px!important}.product-breakdown th[data-v-d300426a],.product-breakdown tr[data-v-d300426a]{width:20px!important}.show-list-button[data-v-d300426a]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
